import * as _ from 'lodash';
import { RegentsSubject } from '../../../../ng2/shared/constants/regents.constant';

angular.module('nv.shared.modals').controller('AssignPrepsForCtrl', AssignPrepsForCtrl);

function AssignPrepsForCtrl($scope, $mdDialog, AssignPrepsForModal, UtilitiesService) {
  $scope.selectedCourses = AssignPrepsForModal.getSelectedCourses();
  $scope.regentsExamKeys = AssignPrepsForModal.getRegentsExamKeys();

  // ng-model for dropdowns
  $scope.prep1 = null;
  $scope.prep2 = null;

  $scope.ngPluralizeOpts = {
    1: '1 course will be assigned as prep for the exams selected in the dropdowns.',
    other: '{} courses will be assigned as prep for the exams selected in the dropdowns.',
  };

  $scope.getRegentsHumanName = function(regentsExamKey) {
    const regentsObj = _.find(RegentsSubject, { key: regentsExamKey });
    return regentsObj ? regentsObj.humanName : regentsExamKey;
  };

  $scope.confirm = function() {
    $mdDialog.hide({ prep1: $scope.prep1, prep2: $scope.prep2 });
  };

  $scope.cancel = () => {
    $mdDialog.cancel();
  };
}
